import generateCheckboxContainer from './generateCheckboxContainer';

export default generateCheckboxContainer('stacked');
